import { useTranslation } from 'react-i18next'
import { $api } from '../../api/queryClient'
import type { EntityLog } from '../../api/schema'
import { useLocale } from '../../contexts/LocaleContext'
import { ActivityEntry } from '../activity/ActivityEntry'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { TooltipProvider } from '../ui/tooltip'

/**
 * The line's activity (spec 2026-10-25-09 §4): who qualified it as
 * recoverable, from what, to what. The endpoint is gated by finance.read, the
 * expense page's own permission, and serves only the recoverable decision.
 */
export function ExpenseActivityCard({ org, expenseUid }: { org: string; expenseUid: string }) {
  const { t } = useTranslation('expenses')
  const { locale } = useLocale()
  const { data } = $api.useQuery('get', '/api/v1/organizations/{orgCode}/expenses/{expenseUid}/logs', {
    params: { path: { orgCode: org, expenseUid } },
  })
  const items = (data?.items ?? []) as EntityLog[]
  return (
    <Card data-testid="expense-activity-card">
      <CardHeader>
        <CardTitle className="text-base">{t('recoverable.activity_title')}</CardTitle>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="expense-activity-empty">{t('recoverable.activity_empty')}</p>
        ) : (
          <TooltipProvider>
            <ul className="space-y-2" data-testid="expense-activity-list">
              {items.map((entry) => <ActivityEntry key={entry.uid} entry={entry} org={org} locale={locale} />)}
            </ul>
          </TooltipProvider>
        )}
      </CardContent>
    </Card>
  )
}
